import type { NetworkParams } from './types'

export const match = (hostname: string): boolean => /awin1\.com/.test(hostname)
export const compactTracking = true

export const apply = (url: URL, params: NetworkParams): void => {
  if (params.trackingId) {
    url.searchParams.set('clickref1', params.trackingId)
    return
  }
  if (params.content) {
    url.searchParams.set('clickref1', `co=${params.content}|${params.utmSearch}|t=${params.term}`)
  } else {
    url.searchParams.set('clickref1', `${params.utmSearch}|t=${params.term}`)
  }
}
